// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { productListStyles } from "@conklin/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import Move from "@insite/mobius/Icons/Move";
import { css } from "styled-components";

productListStyles.centeringWrapper = {
    ...dataTableStyles.centeringWrapper,
};

productListStyles.messageText = {
    ...mergeWithCss(dataTableStyles.noResultsText, {
        css: css`
            margin-top: 12px;
        `,
    }),
};

productListStyles.sortOrderWrapper = {
    css: css`
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 1;
        line-height: 1;
        width: 15px;
        transform: translate(0, -50%);
        @media print {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            width: auto;
            margin: 0;
            top: 12px;
            left: 37px;
            transform: translate(-50%, 0);
        }
    `,
};

productListStyles.dragHandleIcon = {
    src: Move,
    size: 13,
    css: css`
        cursor: move;
        margin: 0 auto;
    `,
};

productListStyles.lineGridItem = {
    width: 12,
    css: css`
        position: relative;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

productListStyles.container = {};

productListStyles.notesTextArea = {
    placeholder: translate("Notes"),
};

productListStyles.wrapper = {};

productListStyles.titleWrapper = {
    css: css`
        background-color: ${color("common.ui17")};
        padding: 15px 20px;
    `,
};

productListStyles.titleText = {
    size: 20,
};
